// src/store/userSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { ENDPOINTS } from "../../../js/api/_config";
import { getAndSetRefreshToken } from "../../../js/api/constants";

// Async thunk for fetching user profile
export const fetchUserProfile = createAsyncThunk(
  "user/fetchUserProfile",
  async (_,{ rejectWithValue }) => {
    try {
      const response = await axios.get(ENDPOINTS.USER.PROFILE);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching user profile:", error);
      return rejectWithValue(error.response?.data || "Failed to fetch user profile");
    }
  }
);

const token = sessionStorage.getItem('authToken') || localStorage.getItem('authToken');
const refreshToken = sessionStorage.getItem('refreshToken') || localStorage.getItem('refreshToken');
let role = 'admin'; // fallback

export const extractUserFromToken = (token) => {
  try {
    const decoded = jwtDecode(token);
    return {
      role: decoded.role,       // assuming JWT has 'role'
      name: decoded.name,       // optional
      email: decoded.email,     // optional
    };
  } catch (error) {
    console.error('Invalid token:', error);
    return undefined;
  }
};



if (token) {
  role = extractUserFromToken(token)?.role;
}

const initialState = {
  token: token,
  refreshToken: refreshToken,
  isAuthenticated: !!token,
  userProfile: [],
  role: role,
  isLoading: true,
  error: null,
};

// Create the slice
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login: (state, action) => {
      const { user, token, refreshToken, rememberMe } = action.payload;
      state.user = user;
      state.token = token;
      state.role = extractUserFromToken(token)?.role;
      state.refreshToken = refreshToken;
      state.isAuthenticated = true;
      if (rememberMe) {
        sessionStorage.setItem('authToken', token);
        sessionStorage.setItem("refreshToken", refreshToken);
      } else {
        localStorage.setItem('authToken', token);
        localStorage.setItem("refreshToken", refreshToken);
      }
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      localStorage.removeItem('authToken');
      localStorage.removeItem("refreshToken");
      sessionStorage.removeItem('authToken');
      sessionStorage.removeItem("refreshToken");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserProfile.pending, (state) => {
        return {
          ...state,
          isLoading: true,
          error: null
        };
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          userProfile: action.payload
        };
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload
        }
      });
  },
});

export const { login, logout } = userSlice.actions;
export default userSlice.reducer;
